// extracted by mini-css-extract-plugin
export var quoteSubtitle = "founderCard-module--quoteSubtitle--jLcRr";
export var wrapper = "founderCard-module--wrapper--5cX3Y";
export var arrow = "founderCard-module--arrow--_1f6v";
export var logo = "founderCard-module--logo--3Vyij";